<script setup lang="ts">
import { Address } from '@/application/shared/domain/Address';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import QuestionCityState from '@/application/shared/infrastructure/components/questions/QuestionCityState.vue';
import { useForm, Field } from 'vee-validate';
import { ref } from 'vue';

const { handleSubmit } = useForm();
const runValidations = handleSubmit(() => true);

const props = withDefaults(defineProps<{
  value?: Partial<Address>;
  addressType?: string;
  id?: string;
  zipReadOnly?: boolean,
  autoFocus?: boolean;
  applicationType: APPLICATION_TYPES;
  validateCoverage?: boolean
}>(), {
  addressType: 'Home',
  autoFocus: false,
  id: 'address'
});

interface EmitInterface {
  (event: 'update:value', value: Partial<Address>): void
  (event: 'setLoading', value: boolean): void;
}

const emits = defineEmits<EmitInterface>();

const emitChange = (): void => {
  emits('update:value', {
    line_one: lineOne.value,
    line_two: lineTwo.value
  });
};

const emitCityStateChange = (value: Partial<Address>): void => {
  emits('update:value', value);
};

const cityState = ref(props.value);

const lineOne = ref(props.value?.line_one);
const lineTwo = ref(props.value?.line_two ?? '');

defineExpose({
  handleSubmit: runValidations
});

</script>
<template>
  <div class="flex flex-col">
    <div class="form-inline">
      <div class="flex flex-col">
        <Field v-model="lineOne" type="text" :name="`${id}-lineOne`" @change="emitChange" v-slot="{ field, errorMessage, meta }" rules="required|at_least_one_number|at_least_one_letter|no_exclamation">
          <input v-bind="field" v-capitalized="field" :class="{ ...meta }" :placeholder="`${addressType} Address`" class="left" v-autofocus="autoFocus">
          <span class="error">{{ errorMessage }}</span>
        </Field>
      </div>
      <div class="md:w-32 flex flex-col">
        <Field v-model="lineTwo" v-slot="{ meta, field }" type="text" :name="`${id}-lineTwo`" @change="emitChange" rules="no_exclamation">
          <input v-bind="field" v-capitalized="field" :class="{ ...meta }" class="right" placeholder="Apt./Ste.">
          <span class="error"></span>
        </Field>
      </div>
    </div>
    <QuestionCityState :value="cityState" @update:value="emitCityStateChange" :id="id" :application-type="applicationType" :zip-read-only="zipReadOnly" :validate-coverage="validateCoverage" @set-loading="val => emits('setLoading', val)" />
  </div>
</template>
